import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import ShuffledRowLimitChoiceType from '../ShuffledRowLimitChoiceType';
import ShuffledOccurrenciesExclusiveChoiceType from '../ShuffledOccurrenciesExclusiveChoiceType';
import messages from '../../../../../res/translations/messages';
import ParameterFormatter from '../ParameterFormatter';

const Battery2Type = ({question}) => (
    <>
        <h4><FormattedMessage {...messages.surveys.form.label.parameterList} /></h4>
        <table className="table table-sm">
            <tbody>
                <tr>
                    <th scope="row"><FormattedMessage {...messages.surveys.form.label.min} /></th>
                    <td><ParameterFormatter value={question.min} /></td>
                </tr>
                <tr>
                    <th scope="row"><FormattedMessage {...messages.surveys.form.label.max} /></th>
                    <td><ParameterFormatter value={question.max} /></td>
                </tr>
            </tbody>
        </table>
        <h4><FormattedMessage {...messages.surveys.form.label.optionList} /></h4>
        <ShuffledOccurrenciesExclusiveChoiceType choices={question.choices} />
        <h4><FormattedMessage {...messages.surveys.form.label.rows} /></h4>
        <ShuffledRowLimitChoiceType choices={question.rows} />
    </>
);

Battery2Type.propTypes = {
    question: PropTypes.object.isRequired,
};

export default Battery2Type;
